import React from 'react';
import request from '../request';

class KendoService {
  static async makeTheCall(url, dataState) {
    const result = request(url, 'post', JSON.stringify(dataState), { 'Content-type': 'application/json' });
    return result;
  }

  static buildFilter(keys, value) {
    const filters = [];
    keys.forEach((key) => {
      const filter = {
        field: key,
        value,
        operator: 'contains',
      };
      filters.push(filter);
    });
    return filters;
  }

  static checkIfValueExistsInFilters(oldFilters, key) {
    let exists = false;
    oldFilters.forEach((f) => {
      if (f.field === key) {
        exists = true;
      }
    });
    return exists;
  }

  static removeFromFilter(oldFilters, keyToRemove) {
    const updatedFilters = [];
    oldFilters.forEach((f) => {
      if (f.field !== keyToRemove) {
        updatedFilters.push(f);
      }
    });
    return updatedFilters;
  }

  static updateFilter(oldFilters, key, value) {
    const updatedFilters = [];
    oldFilters.forEach((f) => {
      const g = f;
      if (f.field === key) {
        g.value = value;
      }
      updatedFilters.push(g);
    });
    return updatedFilters;
  }

  static addFilter(oldFilters, key, value) {
    const updateFilters = oldFilters;
    updateFilters.push({
      field: key,
      value,
      operator: 'contains',
    });
    return updateFilters;
  }

  static mergeFilters(dataState, values) {
    const newDataState = dataState;

    // Create If it doesn't exist
    if (!Object.prototype.hasOwnProperty.call(newDataState, 'filter') || newDataState.filter === null) {
      newDataState.filter = {
        filters: [],
        logic: 'and',
      };
    }
    // Merge Filters
    let { filters } = newDataState.filter;
    Object.keys(values).forEach((key) => {
      if (!KendoService.checkIfValueExistsInFilters(filters, key)) {
        if (values[key] !== '') {
          KendoService.addFilter(filters, key, values[key]);
        }
      } else if (values[key] === '') {
        filters = KendoService.removeFromFilter(filters, key);
      } else {
        filters = KendoService.updateFilter(filters, key, values[key]);
      }
    });

    // Update State
    newDataState.filter.filters = filters;

    return newDataState;
  }

  static removeFromTableById(productsData, id) {
    const newList = [];
    let newCount = 0;
    productsData.data.forEach((item) => {
      if (item.id !== id) {
        newList.push(item);
        newCount += 1;
      }
    });
    return {
      data: newList,
      total: newCount,
    };
  }

  static setPropertyInTableById(productsData, id, property, value) {
    const newList = [];
    productsData.data.forEach((item) => {
      const newItem = item;
      if (item.id === id) {
        newItem[property] = value;
      }
      newList.push(newItem);
    });

    return {
      data: newList,
      total: productsData.total,
    };
  }

  static makeRowsClickable(trElement) {
    const cursor = { cursor: 'pointer' };
    const trProps = { style: cursor };
    return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
  }
}

export default KendoService;
